<template>
<Layout :classes="classes" :header="headerBackgroundColor">

    <TopperShort :data="content.topper.data"></TopperShort>

    <div id="categoryWrapper" class="page-wrapper slices-outer bg-gray-500 px-4 pb-24">

        <CategoryFilters @selection="setFilters($event)" :results="content.results" :filters="content.filters"></CategoryFilters>

        <div class="max-w-4xl mx-auto">
            <section class="category-grid grid gap-4" :class="appState">
                <div v-for="(post, i) in reactivePosts" class="post-container">
                    <PostPreview :post="post" :size="postSize(i)" class="h-full"></PostPreview>
                </div>
                <div v-if="!reactivePosts.length" class="sorry text-gray-800 text-center text-lg">
                    Sorry, no posts matching those terms were found.
                </div>
            </section>
            <div v-if="reactivePagination" class="mt-8 max-w-4xl mx-auto">
                <Pagination @selection="turnToPage($event)" :pages="reactivePagination"></Pagination>
            </div>
        </div>

    </div>

</Layout>
</template>

<script>

import TopperShort from './TopperShort.vue';
import Layout from './Layout.vue';
import CategoryFilters from './CategoryFilters.vue';
import PostPreview from './Utilities/PostPreview.vue';
import Pagination from './Utilities/Pagination.vue';
import { ref, nextTick, computed } from 'vue';
import { inertiaLite, quickCustomEvent, scrollToId } from '../helpers.js';

export default {
    
    props: ['classes', 'content', 'title'],

    setup(props) {

        const appState = ref('idle');
        const reactivePosts = ref(props.content.results.posts);
        const reactivePagination = ref(props.content.results.pagination);
        const reactiveTopic = ref(props.content.results.current_topic);
        const reactiveTag = ref(props.content.results.current_tag);
        const reactivePage = ref(props.content.results.pagination.current);

        const headerBackgroundColor = computed(() => {
            if (props.content.topper.data.format == 'tall') {
                return 'dark';
            }
            return props.content?.topper?.data?.options?.color_scheme || 'light';
        });

        const postSize = (i) => {
            const bigs = [1, 4, 5, 8, 9, 12];
            return (bigs.indexOf(i + 1) > -1)
                ? 'big'
                : 'small';
        };

        const turnToPage = async (e) => {
            reactivePage.value = e;
            await getResults();
            scrollToId('categoryWrapper');
        };

        const setFilters = async (e) => {
            reactivePage.value = 1;
            reactiveTopic.value = (e.topic)
                ? e.topic
                : null;
            reactiveTag.value = (e.tag)
                ? e.tag
                : null;
            await getResults();
            scrollToId('categoryWrapper');
        };

        const getResults = async () => {

            let rootUrl = new URL(window.location);
            let requestUrl = new URL(rootUrl.origin + '/category/' + props.content.category.slug);

            requestUrl.searchParams.set('_paged', reactivePage.value);

            if (reactiveTopic.value) {
                requestUrl.searchParams.set('topic', reactiveTopic.value);
            }

            if (reactiveTag.value) {
                requestUrl.searchParams.set('tag', reactiveTag.value);
            }

            appState.value = 'switching';
            let [newResults] = await Promise.all([inertiaLite(requestUrl.toString()), window.wait(350)]);

            reactivePosts.value = newResults.props.content.results.posts;
            reactivePagination.value = newResults.props.content.results.pagination;
            await nextTick();
            window.history.pushState({}, '', requestUrl);
            appState.value = 'idle';
        };

        return {
            appState,
            headerBackgroundColor,
            pagination: props.content.pagination || null,
            postSize,
            reactivePosts,
            reactivePagination,
            reactiveTag,
            reactiveTopic,
            turnToPage,
            setFilters
        }

    },

    components: {
        TopperShort,
        Layout,
        Pagination,
        PostPreview,
        CategoryFilters
    }

}
</script>